"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStaticAssetUrl = void 0;
function getStaticAssetUrl(baseUrl, resourceKey) {
    return encodeURI(`${baseUrl}/${resourceKey}`);
}
exports.getStaticAssetUrl = getStaticAssetUrl;
//# sourceMappingURL=media.js.map